<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <AppLoader
        v-if="
          generalSettings === null ||
          (authToken !== null && authUser.user === null)
        "
        key="loading"
      />
      <div
        v-else-if="
          generalSettings.general.maintenance.enabled === false ||
          (authUser.user !== null && authUser.user.rank === 'admin')
        "
        class="app-page"
        key="page"
      >
        <Sidebar :mobile-open="mobileSidebarOpen" @close-mobile="mobileSidebarOpen = false" />
        <button class="sidebar-toggle" @click="mobileSidebarOpen = !mobileSidebarOpen">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6h16M4 12h16M4 18h16" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
        <div class="container">
          <Navbar @toggle-sidebar="mobileSidebarOpen = !mobileSidebarOpen" />
          <main
            v-bind:class="{ 'main-background': appHasBackground === true }"
            ref="mainContainer"
          >
            <transition name="slide-fade" mode="out-in">
              <router-view />
            </transition>
            <Footer />
          </main>
        </div>

        <Modals />
        <Notifications />
        <Chat />
      </div>
      <AppMaintenance v-else key="maintenance" />
    </transition>
    <div v-if="mobileSidebarOpen" class="sidebar-overlay" @click="mobileSidebarOpen = false"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppLoader from "@/components/AppLoader";
import AppMaintenance from "@/components/AppMaintenance";
import Chat from "@/components/chat/Chat";
import Modals from "@/components/modals/Modals";
import Notifications from "@/components/notifications/Notifications";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/home/footer/Footer.vue";
import Navbar from "@/components/newNavbar/Navbar";

export default {
  components: {
    AppLoader,
    AppMaintenance,
    Navbar,
    Chat,
    Footer,
    Modals,
    Notifications,
    Sidebar,
  },
  data() {
    return { mobileSidebarOpen: false };
  },
  methods: {
    ...mapActions(["socketConnectGeneral"]),
  },
  computed: {
    ...mapGetters([
      "socketGeneral",
      "generalSettings",
      "authToken",
      "authUser",
    ]),
    appGetRouteName() {
      return this.$route.name;
    },
    appHasBackground() {
      let background = true;

      if (
        [
          "ProfileTransactions",
          "ProfileGames",
          "ProfileSettings",
          "UnboxOverview",
          "UnboxBox",
          "BattlesOverview",
          "BattlesCreate",
          "BattlesGame",
          "CashierLimiteds",
        ].includes(this.appGetRouteName) === true
      ) {
        background = false;
      }

      return background;
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        if (this.$refs.mainContainer !== undefined) {
          this.$nextTick(() => {
            const mainContainer = this.$refs.mainContainer;
            mainContainer.scrollTo({ top: 0, behavior: "smooth" });
          });
        }
      },
    },
  },
  created() {
    this.socketConnectGeneral();
  },
};
</script>

<style>
body .app-loader.fade-leave-active {
  transition: opacity 0.5s ease;
}

body .app-loader.fade-leave-active {
  opacity: 0;
}

body .app-page {
  width: 100vw;
  height: 100vh;
  display: flex;
}

body .app-page.fade-enter-active,
body .app-maintenance.fade-enter-active {
  transition: opacity 0.5s ease;
}

body .app-page.fade-enter-from,
body .app-maintenance.fade-enter-from {
  opacity: 0;
}
.container {
  position: relative;
  width: 100%;
}
body .app-page main {
  width: 100%;
  height: 100%;
  max-width: 75rem;
  margin-left: auto;
  margin-right: auto;
  padding-top: 50px;
  top: 100px;
  right: 325px;
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

body .app-page main::-webkit-scrollbar-track {
  background-color: transparent;
}

body .app-page main::-webkit-scrollbar-thumb {
  background-color: transparent;
}

body .app-page main::-webkit-scrollbar {
  width: 0;
  height: 0;
}

body .app-page main .slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

body .app-page main .slide-fade-enter {
  opacity: 0;
}

@media only screen and (max-width: 1500px) {
  body .app-page main {
    width: 100%;
    right: 0;
  }
}

@media only screen and (max-width: 1175px) {
  body .app-page main {
    /* height: calc(100% - 80px); */
    top: 80px;
  }
}
</style>

<style>
@media only screen and (max-width: 780px) {
  .sidebar-toggle {
    position: fixed;
    left: 12px;
    top: 80px;
    z-index: 45;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #2a2d32;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }
}

@media only screen and (min-width: 781px) {
  .sidebar-toggle { display: none; }
}

.sidebar-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 35;
}
</style>
